const DEFAULT_PRIORITY = 'FGTS';

const isProduct = (product) => product !== null
  && typeof product === 'object'
  && typeof product.label === 'string'
  && Array.isArray(product.routes)
  && product.routes.length > 0;

export function readQuickAccess() {
  try {
    const products = JSON.parse(localStorage.getItem('quick_access'));

    return Array.isArray(products) ? products.filter(isProduct) : [];
  } catch {
    return [];
  }
}

export function prioritizeProducts(products, priority) {
  const pinned = priority || DEFAULT_PRIORITY;
  const flagged = products.map((product) => ({ ...product, isPriority: product.label === pinned }));

  return [
    ...flagged.filter(({ isPriority }) => isPriority),
    ...flagged.filter(({ isPriority }) => !isPriority),
  ];
}
